// source: pbtypes/gen/skills/ui_variables.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_skills_key_value_pb = require('../../../pbtypes/gen/skills/key_value_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_key_value_pb);
goog.exportSymbol('proto.skills.UiVariablesPb', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.UiVariablesPb = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.skills.UiVariablesPb.repeatedFields_, null);
};
goog.inherits(proto.skills.UiVariablesPb, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.UiVariablesPb.displayName = 'proto.skills.UiVariablesPb';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.skills.UiVariablesPb.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.UiVariablesPb.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.UiVariablesPb.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.UiVariablesPb} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.UiVariablesPb.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
lastTransitionUtime: jspb.Message.getFieldWithDefault(msg, 2, 0),
varsList: jspb.Message.toObjectList(msg.getVarsList(),
    pbtypes_gen_skills_key_value_pb.KeyValue.toObject, includeInstance),
boostCommanded: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.UiVariablesPb}
 */
proto.skills.UiVariablesPb.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.UiVariablesPb;
  return proto.skills.UiVariablesPb.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.UiVariablesPb} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.UiVariablesPb}
 */
proto.skills.UiVariablesPb.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setLastTransitionUtime(value);
      break;
    case 3:
      var value = new pbtypes_gen_skills_key_value_pb.KeyValue;
      reader.readMessage(value,pbtypes_gen_skills_key_value_pb.KeyValue.deserializeBinaryFromReader);
      msg.addVars(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBoostCommanded(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.UiVariablesPb.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.UiVariablesPb.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.UiVariablesPb} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.UiVariablesPb.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getLastTransitionUtime();
  if (f !== 0) {
    writer.writeSint64(
      2,
      f
    );
  }
  f = message.getVarsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      pbtypes_gen_skills_key_value_pb.KeyValue.serializeBinaryToWriter
    );
  }
  f = message.getBoostCommanded();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional sint64 utime = 1;
 * @return {number}
 */
proto.skills.UiVariablesPb.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.UiVariablesPb} returns this
 */
proto.skills.UiVariablesPb.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional sint64 last_transition_utime = 2;
 * @return {number}
 */
proto.skills.UiVariablesPb.prototype.getLastTransitionUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.UiVariablesPb} returns this
 */
proto.skills.UiVariablesPb.prototype.setLastTransitionUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated KeyValue vars = 3;
 * @return {!Array<!proto.skills.KeyValue>}
 */
proto.skills.UiVariablesPb.prototype.getVarsList = function() {
  return /** @type{!Array<!proto.skills.KeyValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_skills_key_value_pb.KeyValue, 3));
};


/**
 * @param {!Array<!proto.skills.KeyValue>} value
 * @return {!proto.skills.UiVariablesPb} returns this
*/
proto.skills.UiVariablesPb.prototype.setVarsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.skills.KeyValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.skills.KeyValue}
 */
proto.skills.UiVariablesPb.prototype.addVars = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.skills.KeyValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skills.UiVariablesPb} returns this
 */
proto.skills.UiVariablesPb.prototype.clearVarsList = function() {
  return this.setVarsList([]);
};


/**
 * optional bool boost_commanded = 4;
 * @return {boolean}
 */
proto.skills.UiVariablesPb.prototype.getBoostCommanded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skills.UiVariablesPb} returns this
 */
proto.skills.UiVariablesPb.prototype.setBoostCommanded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


goog.object.extend(exports, proto.skills);
